import moment from 'moment';
import type Moment from 'moment';

import type {AvailabilityDay} from 'nutshell-graphql-types';
import type {SetAvailability_availabilitySet_availability_times as AvailabilityTime} from 'nutshell-graphql-types';

export const DAYS_OF_WEEK = [
    'SUNDAY',
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
] as const;

// @ts-expect-error
export const convertTimeStringToMoment = (time: string): Moment => {
    const parts = time.split(':');

    return moment()
        .add(1, 'days')
        .set({hour: Number(parts[0]), minute: Number(parts[1])});
};

export const getDefaultAvailabilityTimesForDay = (
    dayOfWeek: AvailabilityDay
): AvailabilityTime[] => {
    return [
        {
            __typename: 'AvailabilityTime',
            day: dayOfWeek,
            startTime: '09:00',
            endTime: '17:00',
        },
    ];
};

export function bucketAvailabilityTimesByDay(availabilityTimes: AvailabilityTime[]): any {
    return DAYS_OF_WEEK.reduce<Record<string, any>>((acc, currentDay) => {
        acc[currentDay] = availabilityTimes.filter((time) => time.day === currentDay);

        return acc;
    }, {});
}

// If the startTime is updated, we need to update the endTime if it is invalid (less than startTime)
// @ts-expect-error
export const getValidEndTime = (newStartTime: Moment, endTime: string) => {
    if (newStartTime.format('HH:mm') >= endTime) {
        const newEndTime = newStartTime.clone().add(15, 'm');

        return newEndTime;
    }

    return convertTimeStringToMoment(endTime);
};

// If the endTime is updated, we need to update the startTime if it is invalid (greater than endTime)
// @ts-expect-error
export const getValidStartTime = (startTime: string, newEndTime: Moment) => {
    if (newEndTime.format('HH:mm') <= startTime) {
        const newStartTime = newEndTime.clone().subtract(15, 'm');

        return newStartTime;
    }

    return convertTimeStringToMoment(startTime);
};
